import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';
import { useTheme } from '@mui/material';

var ChartLayoutLarge = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  z-index: 3;\n\n  svg {\n    overflow: visible;\n  }\n"], ["\n  width: 100%;\n  z-index: 3;\n\n  svg {\n    overflow: visible;\n  }\n"])));
var ChartLayoutMini = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", "px;\n  width: 100%;\n  display: block;\n  margin-bottom: 10px;\n  position: relative;\n  &:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    z-index: 5;\n  }\n"], ["\n  height: ", "px;\n  width: 100%;\n  display: block;\n  margin-bottom: 10px;\n  position: relative;\n  &:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    z-index: 5;\n  }\n"])), function (props) { return props.height || 100; });
var useAxisStyle = function () {
    var theme = useTheme();
    return {
        axisLabel: {
            fontSize: 20,
            padding: 30,
            fill: theme.palette.neutral200,
            fontFamily: theme.typography.fontFamily,
            letterSpacing: 0.55,
            lineHeight: 16,
        },
        tickLabels: {
            fontSize: 11,
            padding: 7,
            fill: theme.palette.neutral200,
            fontFamily: theme.typography.fontFamily,
            letterSpacing: 0.55,
            lineHeight: 16,
        },
    };
};
var templateObject_1, templateObject_2;

export { ChartLayoutLarge, ChartLayoutMini, useAxisStyle };
